import { Skeleton } from "@mui/material";
import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import ProtectedRoute from "src/components/auth-routes/ProtectedRoute";

import PatientProvider from "src/context/PatientProvider";

const KnowledgeAssistant = lazy(
  () => import("src/components/KnowledgeAssistant"),
);

const ProtectedLayout = () => {
  return (
    // This is a very basic version of the layout with time, we can update it and add more if necessary.
    <ProtectedRoute>
      <PatientProvider>
        <Outlet />
        <Suspense fallback={<Skeleton variant="circular" height={56} />}>
          <KnowledgeAssistant />
        </Suspense>
      </PatientProvider>
    </ProtectedRoute>
  );
};

export default ProtectedLayout;
